import { LOCAL_STORAGE_KEY } from '../constants/generals';

interface IUserData {
    token?: string;
    accessLevel: string;
    isLoggedIn: boolean;
    Organization: string;
    LogoURL?: string;
    OrganizationName: string;
    userUID: string;
    category?: string;
}

export function saveUserDataToLS(userData: IUserData) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(userData));
}

export function getUserData() {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
}

export function removeUserData() {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/utilityServices.ts